<template>
  <div id="pie-chart">
    <div class="rose-chart-title">长短租比例</div>
    <dv-charts :option="option"/>
  </div>
</template>

<script>
export default {
  name: 'RoseChart',
  data () {
    return {
      option: {
        series: [
          {
            type: 'pie',
            radius: '50%',
            roseSort: false,
            data: [
              { name: '长租', value: 66 },
              { name: '短租', value: 34 }
            ],
            insideLabel: {
              show: false
            },
            outsideLabel: {
              formatter: '{name} {percent}%',
              labelLineEndLength: 20,
              style: {
                fill: '#fff'
              },
              labelLineStyle: {
                stroke: '#fff'
              }
            },
          }
        ],
        color: ['#4d99fc', '#38dad4']
      }

    }
  }
}
</script>

<style lang="less">
#pie-chart {
  width: 100%;
  height: 400px;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, .5);
  box-sizing: border-box;

  .rose-chart-title {
    height: 50px;
    font-weight: bold;
    text-indent: 20px;
    font-size: 20px;
    display: flex;
    align-items: center;
  }

  .dv-charts-container {
    width: 100%;
    //height: calc(~"100% - 50px");
  }
}
</style>
